import { CompactButton, StandardButton } from '@/components/buttons';
import { ContentPanel } from '@/components/content-panel';
import { CurbyAccordion } from '@/components/curby-accordion';
import { CurbyHeader } from '@/components/curby-header';
import { PrimaryLayout } from '@/layouts/primary';
import { Flex, Text, Title } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { AccordionLocation } from '../../../../backend/src/types.generated';
import styles from './styles.module.css';

export const InformExisting = () => {
	const navigate = useNavigate();

	const closeButton = useMemo(
		() => (
			<CompactButton leftSection={<IconX />} onClick={() => navigate({ to: '/home' })}>
				Close
			</CompactButton>
		),
		[navigate]
	);

	const accountButton = useMemo(
		() => (
			<StandardButton
				onClick={() => navigate({ to: '/account', search: { to: 'choose-subscription' } })}
			>
				Continue
			</StandardButton>
		),
		[navigate]
	);

	return (
		<PrimaryLayout
			header={{ title: 'Updates', children: closeButton }}
			footer={{ children: accountButton }}
		>
			<ContentPanel>
				<Flex direction="column" gap="lg" mb="lg" mt="lg">
					<CurbyHeader>
						<Title order={1} className={styles.title}>
							Welcome to Curby Rewards!
						</Title>
					</CurbyHeader>
					<Text size="sm">
						We’re thrilled to have you on board as we launch Australia’s first fully transparent
						solution for soft plastic recycling. Thanks to your efforts, and the support of over
						31,000 Australians, we’re taking big steps to keep soft plastics out of landfill and our
						environment.
					</Text>
					<Text size="sm">
						With the new Curby App, recycling is easier, faster, and more rewarding than ever.
						Here’s what’s new:
					</Text>
				</Flex>
				<CurbyAccordion accordionLocation={AccordionLocation.InformExisting} />
				<Flex direction="column" gap="lg" mb="lg" mt="lg">
					<Text size="sm">
						With Curby, you can recycle with confidence—knowing your soft plastics are being sorted,
						processed, and transformed into valuable products. Plus, our Curby Rewards program makes
						it even more exciting with great prizes up for grabs!
					</Text>
					<Text size="sm" fw={700}>
						It’s simple: bag it, scan it, and bin it.
					</Text>
				</Flex>
			</ContentPanel>
		</PrimaryLayout>
	);
};
